export default {"src":"https://assets.madeeasy.in/prod/_next/static/media/three-buildings.08034a76.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};